import React from "react";
import { AppBar, Toolbar, Box, IconButton, Badge } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { LogoutOutlined, NotificationsOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  color: theme.palette.text.primary,
}));

const LogoutButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.error.main,
  textTransform: "none",
  "&:hover": {
    backgroundColor: alpha(theme.palette.error.main, 0.08),
  },
}));

const NotificationButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
}));

const TopNav = ({ currentScreen, setCurrentScreen }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <StyledAppBar position="sticky">
      <Toolbar>
        {/* <img
          src={require("../assets/coloredLogo.png")}
          alt="Logo"
          style={{ height: 40, marginRight: 24 }}
        /> */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Notifications Bell Icon */}
        <NotificationButton>
          <Badge badgeContent={4} color="error">
            <NotificationsOutlined />
          </Badge>
        </NotificationButton>

        {/* Logout Button */}
        <LogoutButton onClick={handleLogout}>
          <LogoutOutlined />
        </LogoutButton>
      </Toolbar>
    </StyledAppBar>
  );
};

export default TopNav;
